<template>
  <div class="modal_available_config">
    <div class="header">
      <h4 class="title">
        {{ translate('config.select_group_config') }}
      </h4>
    </div>

    <div class="content">

      <div class="filter">
        <label class="info"> Выберите конфиг </label>
        <tree-select
            class="select"
            v-model="select_config"
            :options="config_list"
            :searchable="true"
            :clearable="false"
            placeholdder="Выберите конфиг"
        />
      </div>
    </div>

    <div class="text-center">
      <span
          :disabled="select_config === null || select_config === ''"
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="next"
      >
        {{ translate('config.next') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>

export default {
  name: "AvailableDeviceConfigs",
  props: ["device_fid"],
  components: {
  },
  data () {
    return {
      available_configs: [],
      select_config: null
    }
  },

  computed:{
    config_list(){
      return this.available_configs.map((item, key) => {
        return { id: key, label: item.name}
      })
    }
  },

  created() {
    this.get_available_configs()
  },

  methods: {
    get_available_configs(){
      this.$http.v1.getAvailableDeviceConfigs(this.device_fid, (response) => {
        this.available_configs = response.data
      })
    },
    cancel () {
      this.$emit('close')
    },
    next(){
      if (this.select_config !== null && this.select_config !== ''){
        this.$emit("next", this.available_configs[this.select_config])
      }
    },
  }
}

</script>

<style lang='scss'>
  .modal_available_config{
    padding: 10px;
    .header{
      text-align: center;
      .title{
        margin: 0 0 10px 0;
      }
    }
    .content{
      height: 400px;
    }
  }
</style>
